/**
 * Title comparison key shared by the server (Studio Team / Album / bulk title
 * check) and the browser (RiffWriter): lowercase, straight quotes, punctuation
 * collapsed -- "The LEDGER!" and "the ledger" are the same title.
 */
export function normalizeTitle(t: string): string {
  return (t || '').toLowerCase().replace(/[’‘]/g, "'").replace(/[^a-z0-9']+/g, ' ').replace(/'/g, '').trim();
}
